import { m8API } from 'services/production/m8';
import { normalizeM8StatementDTO } from 'services/production/utils/normalizeM8StatementDTO';
import { GetGiroPaymentService } from 'types/services';

export const getGiroPayment: GetGiroPaymentService = async (paymentId) => {
  const m8StatementDTO = await m8API.admin.getStatementById({
    idStatement: paymentId,
  });

  return normalizeM8StatementDTO(m8StatementDTO).toGiroPayment(
    normalizeM8StatementDTO(m8StatementDTO).toPerson(),
    normalizeM8StatementDTO(m8StatementDTO).toOrg()
  );
};
